import PropTypes from 'prop-types';

const CountdownBar = ({ seconds = 30, total = 30 }) => {
    const percent = Math.min(100, Math.max(0, (seconds / total) * 100));
    return (
        <div className="w-full h-1 bg-gray-900 rounded-full overflow-hidden" data-testid="countdown-bar">
            <div
                className="h-full bg-success-300 rounded-full transition-all duration-1000 ease-linear"
                style={{ width: `${percent}%` }}
                data-testid="countdown-bar-fill"
            />
        </div>
    );
};

CountdownBar.propTypes = {
    seconds: PropTypes.number,
    total: PropTypes.number
};

export default CountdownBar;
